<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" class="text-center title black--text">
        <p>You have reached the end of the survey.</p>
        <p>Thank you for your time and and for your contribution towards the<br>
          Benchmarking Infrastructure 2020 {{ $store.state.survey.name }} Survey.</p>
        <p class="pa-5">We would like to invite you to review your answers once again. Should you wish to review your answers, please click on the button below.</p>
        <v-btn v-on:click="reviewAll" large color="primary">Review All Questions</v-btn>
      </v-col>
    </v-row></div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(["allSurveyQuestions"])
  },
  methods: {
    reviewAll() {
      this.$store.commit('setReviewType', 'all')
      this.$router.push(`/survey/${this.$route.params.questions}/${this.allSurveyQuestions[0]}/`)
    }
  }
}
</script>